import { useTranslation } from 'react-i18next';

interface PricingCardProps {
  price: number;
  unit: string;
  quantityAvailable?: number;
}

export function PricingCard({
  price,
  unit,
  quantityAvailable,
}: PricingCardProps) {
  const { t } = useTranslation('product');
  return (
    <div className="bg-neut-50 rounded-lg p-6">
      <div className="flex items-baseline gap-2 mb-2">
        <span
          data-testid="product-price"
          className="text-3xl text-neutral-900 font-semibold"
        >
          ${price}
        </span>
        <span className="text-lg text-neutral-600 font-normal">/ {unit}</span>
      </div>
      <div className="flex items-center gap-2 text-sm">
        {(quantityAvailable || 0) > 0 ? (
          <span className="px-2 py-1 rounded-full font-medium bg-prim-100 text-prim-600">
            {t('product.in_stock')}
          </span>
        ) : (
          <span className="px-2 py-1 rounded-full font-medium bg-error-100 text-error-600">
            {t('product.out_of_stock')}
          </span>
        )}

        <span className="text-neutral-600 font-normal">
          {`${(quantityAvailable || 0).toLocaleString()} ${unit} available`}
        </span>
      </div>
    </div>
  );
}
